import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Success = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      bgcolor="#f0fff4"
      px={3}
    >
      {/* <CheckCircleOutline sx={{ fontSize: 80, color: 'green' }} /> */}
      <Typography variant="h4" mt={2} fontWeight="bold">
        Payment Successful
      </Typography>
      <Typography variant="body1" mt={1} mb={3}>
        Thank you for your purchase! Your transaction has been completed.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/')}
      >
        Go to Home
      </Button>
    </Box>
  );
};

export default Success;
